import * as React from "react";
import { forwardRef } from "react";
const SvgPopOutIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.25 17.25H6.75V6.75H12V5.25H6.75C5.9175 5.25 5.25 5.925 5.25 6.75V17.25C5.25 18.075 5.9175 18.75 6.75 18.75H17.25C18.075 18.75 18.75 18.075 18.75 17.25V12H17.25V17.25ZM13.5 5.25V6.75H16.1925L8.82 14.1225L9.8775 15.18L17.25 7.8075V10.5H18.75V5.25H13.5Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgPopOutIcon);
export { ForwardRef as ReactComponent };
